import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { Field, reduxForm } from 'redux-form';
import { ButtonToolbar, Button, Label } from 'reactstrap';
import PropTypes from 'prop-types';
import Select from '../../../shared/components/form/Select';
import renderCheckBoxField from '../../../shared/components/form/CheckBox';
import DateField from '../../../shared/components/form/DateField';
import MedicationStatusSelector from './MedicationStatusSelector';
import validate from './ValidateFilter';

const MedicationFilter = (props) => {
  const { t, handleSubmit, initialize, lastFilter, students } = props;
  const [maxDate, setMaxDate] = useState(new Date());

  useEffect(() => {
    initialize(lastFilter);
  }, [lastFilter]);

  return (
    <MuiThemeProvider>
      <form className="form justify-content-end" onSubmit={handleSubmit}>
        <div className="form__form-group--2_columns">
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('general.student')}
            </span>
            <div className="form__form-group-field">
              <Field
                name="student"
                component={Select}
                options={students}
                placeholder={t('general.placeholders.select')}
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('general.request-date')}
            </span>
            <div className="form__form-group-field">
              <Field
                name="requestDate"
                component={DateField}
                placeholder={t('general.placeholders.date')}
                isClearable
              />
            </div>
          </div>
        </div>
        <div className="form__form-group--2_columns">
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('general.request-initial-date')}
            </span>
            <div className="form__form-group-field">
              <Field
                name="requestInitialDate"
                component={DateField}
                placeholder={t('general.placeholders.date')}
                isClearable
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('general.request-final-date')}
            </span>
            <div className="form__form-group-field">
              <Field
                name="requestFinalDate"
                component={DateField}
                onChange={setMaxDate}
                minDate={maxDate}
                placeholder={t('general.placeholders.date')}
                isClearable
              />
            </div>
          </div>
        </div>
        <div className="form__form-group-field">
          <Field
            name="hasRecipe"
            component={renderCheckBoxField}
            defaultValue
            className="colored-click"
          />
          <Label className="generic__label">{t('general.only-recipe')}</Label>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label bold-text">
            {t('general.status')}
          </span>
          <div className="form__form-group-field pt-3">
            <Field name="status" component={MedicationStatusSelector} />
          </div>
        </div>
        <ButtonToolbar
          className="form__button-toolbar"
          style={{ justifyContent: 'flex-end' }}
        >
          <Button color="success" type="submit">
            {t('general.filter')}
          </Button>
        </ButtonToolbar>
      </form>
    </MuiThemeProvider>
  );
};

MedicationFilter.propTypes = {
  t: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  initialize: PropTypes.func.isRequired,
  lastFilter: PropTypes.shape(
    PropTypes.shape({
      hasRecipe: PropTypes.bool,
      student: PropTypes.shape({
        value: PropTypes.number,
      }),
      requestDate: PropTypes.instanceOf(Date),
      initialDate: PropTypes.instanceOf(Date),
      finalDate: PropTypes.instanceOf(Date),
    })
  ).isRequired,
  students: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number,
      label: PropTypes.string,
    })
  ).isRequired,
};

export default withTranslation('common')(
  reduxForm({
    form: 'MedicationFilterForm',
    validate,
  })(MedicationFilter)
);
